import { useState } from 'react';
import { R } from '@/features/booking/resources/Texts.resx';
import { NavigationItem, Card } from '@/components';
import { CatIcon, DogIcon, RabbitIcon, RodentIcon } from '@/components/Icons';
import { IPetDto } from '@/shared/interfaces';
import { useUrlState } from '@/features/booking/shared/model/useUrlState';
import { fetchPets } from '@/api/pets/fetchPets';
import { useQuery } from '@tanstack/react-query';
import { PetTypeEnum } from '@/shared/enums';
import { PetModal } from '@/features/profile/widgets/pets/ui/PetModal';

interface SelectPetProps {
    onSelectPet: (pet: IPetDto) => void;
}

const petTypeIcons: Record<PetTypeEnum, JSX.Element> = {
    [PetTypeEnum.Dog]: <DogIcon className="icon-box" />,
    [PetTypeEnum.Cat]: <CatIcon className="icon-box" />,
    [PetTypeEnum.Rabbit]: <RabbitIcon className="icon-box" />,
    [PetTypeEnum.Rodent]: <RodentIcon className="icon-box" />,
};

const getIcon = (petType: PetTypeEnum) => {
    return petTypeIcons[petType] ?? <DogIcon className="icon-box" />;
};

export const SelectPet = ({ onSelectPet }: SelectPetProps) => {
    const { urlState } = useUrlState();
    const [showAddPetModal, setShowAddPetModal] = useState(false);

    const isSelected = (uid: string) => {
        return uid === urlState.petId;
    };

    const { data: pets, refetch } = useQuery({
        queryKey: ['pets'],
        queryFn: fetchPets,
        enabled: true,
        staleTime: 1000 * 60 * 2, // 2min
    });

    return (
        <Card alwaysCard={false}>
            <div className="space-y-4">
                <h2 className="mb-6">{R.WhoNeedsHelp}</h2>

                {pets?.map((pet) => {
                    return (
                        <NavigationItem
                            key={pet.Id}
                            className={isSelected(pet.Id) ? '' : ''}
                            onClick={() => onSelectPet(pet)}
                            caption={pet.Name}
                            icon={getIcon(pet.Type)}
                        />
                    );
                })}

                <NavigationItem
                    onClick={() => setShowAddPetModal(true)}
                    caption={R.AddPet}
                />
            </div>

            {showAddPetModal && (
                <PetModal
                    onClose={(reload) => {
                        if (reload) refetch();
                        setShowAddPetModal(false);
                    }}
                    pet={null}
                />
            )}
        </Card>
    );
};
